import { CategoryLeaderboardGroupTableRow } from './CategoryLeaderboardGroupTableRow';
import { CategoryLeaderboardGroupingPgKpi } from '@models/CategoryLeaderboard';
import { ColumnConfig } from '@components/design/migrated/Table';
import { Filters, ShareType } from '@utils/pageConfig/Types';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import React from 'react';
import { GroupContext } from '@utils/userPreferencesUtils/Types';

interface Props {
  categoryLeaderboardGroups: CategoryLeaderboardGroupingPgKpi[];
  countries: Filters;
  currencySymbol: string;
  columns: ColumnConfig[];
  sortedColumn: string;
  selectedShareType: ShareType;
  selectedGrowthType: GrowthTypes;
  context: GroupContext;
  isExplorePage?: boolean;
}

/**
 * @return CategoryLeaderboardGroupTableRow
 *
 * @remarks
 * to return multiple groups row
 *
 * @param categoryLeaderboardGroups - response return from leaderboard api
 * @param countries - Filters country
 * @param columns - table columns
 * @param sortedColumn - current sorted column
 * @param currencySymbol - Currency symbol
 * @param selectedShareType
 * @param selectedGrowthType
 * @param context -contains retailer client and country
 * @param isExplorePage - is current page explore page
 * **/
export const CategoryLeaderboardGroupTableRows: React.FC<Props> = ({
  categoryLeaderboardGroups,
  countries,
  columns,
  sortedColumn,
  currencySymbol,
  selectedShareType,
  selectedGrowthType,
  context,
  isExplorePage,
}) => {
  return (
    <>
      {categoryLeaderboardGroups.map(({ groupDetails, groupKpis }) => (
        <CategoryLeaderboardGroupTableRow
          key={groupDetails.groupName}
          groupDetails={groupDetails}
          categoryLeaderboardPgs={groupKpis}
          countries={countries}
          currencySymbol={currencySymbol}
          sortedColumn={sortedColumn}
          columns={columns}
          selectedShareType={selectedShareType}
          selectedGrowthType={selectedGrowthType}
          context={context}
          isExplorePage={isExplorePage}
        ></CategoryLeaderboardGroupTableRow>
      ))}
    </>
  );
};
